// Lightweight in-memory cache shared across admin page mounts.
// Admin pages are separate routes, so each navigation remounts the component
// and would otherwise refetch from the backend. This cache lets a page render
// instantly from the last result and skip the network call while still fresh.

const store = new Map(); // key -> { data, ts }
const DEFAULT_TTL = 2 * 60 * 1000; // 2 minutes

export const getCache = (key) => {
  const entry = store.get(key);
  return entry ? entry.data : null;
};

export const isFresh = (key, ttl = DEFAULT_TTL) => {
  const entry = store.get(key);
  return !!entry && Date.now() - entry.ts < ttl;
};

export const setCache = (key, data) => {
  store.set(key, { data, ts: Date.now() });
};

// Drop cached entries so the next mount refetches (e.g. after a mutation).
export const invalidate = (...keys) => {
  if (keys.length === 0) store.clear();
  else keys.forEach((k) => store.delete(k));
};
